// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iyJZG","col":"styles_col__1qDa3"};